import { Profile } from '../../../../../types/persona'
import { AboutSection } from '../profiles/AboutSection'
import { CertificationSection } from '../profiles/CertificationSection'
import { CourseSection } from '../profiles/CourseSection'
import { EducationSection } from '../profiles/EducationSection'
import { EventSection } from '../profiles/EventSection'
import { ProjectSection } from '../profiles/ProjectSection'
import { SkillSection } from '../profiles/SkillSection'

export function ProfileTab({ profile }: { profile?: Profile }) {
  return (
    <>
      <AboutSection summary={profile?.summary} />
      <EducationSection education={profile?.education ?? []} />
      <CertificationSection certifications={profile?.certifications ?? []} />
      <ProjectSection projects={profile?.projects ?? []} />
      <SkillSection skills={profile?.skills ?? []} />
      <EventSection events={profile?.events ?? []} />
      <CourseSection courses={profile?.courses ?? []} />
    </>
  )
}
